<template>
    <ASelect
        mode="multiple"
        v-model:value="valueState"
        placeholder="Pilih Entitas"
        allow-clear
        show-search
        :not-found-content="onHandleContent()"
        option-filter-prop="label"
        option-label-prop="label"
        @search="onSearch"
        @blur="() => (state.params.q = null)"
        @select="() => (state.params.q = null)"
        v-bind="$attrs"
        :loading="state.loading"
        :show-arrow="true"
        style="width:300px">
        <ASelectOption v-for="d in state.data" :key="d.id" :label="d.name">
            <span v-html="highlight(d.name)"></span>
        </ASelectOption>
        <template v-if="state.loading" #notFoundContent>
            <ASpin size="small" />
        </template>
    </ASelect>
</template>

<script>
import { onMounted, reactive, watch } from 'vue'
import apiClient from '@/services/axios'
import { useVModel } from '@/components/useVModel.js'
import { debounce, isEmpty, pickBy } from 'lodash'

export default {
    props: {
        value: {
            type: [Array, Number, Object, String],
            default: null,
        },
        level: {
            type: [Array, Number, String],
            default: null,
        },
    },
    emits: ['update:value'],
    setup(props, { emit }) {
        const state = reactive({
            endpoint: `/api/filter/list-entitas`,
            loading: false,
            data: [],
            params: {
                q: '',
                level: props.level,
            },
            error: {},
        })

        const fetchData = () => {
            state.loading = true
            apiClient.get(state.endpoint, { params: pickBy(state.params) })
                .then(({ data }) => {
                    state.data = data

                    // reset error
                    state.error = {}
                })
                .catch(({ response: { data } }) => {
                    state.error = data

                    // reset data
                    state.data = []
                })
                .finally(() => {
                    state.loading = false
                })
        }

        onMounted(() => {
            fetchData()
        })

        watch(() => props.level, () => {
            state.params.level = props.level
        })

        watch(state.params, debounce(() => {
            fetchData()
        }, 300))

        const onSearch = value => {
            state.params.q = value
        }

        const onHandleContent = () => {
            let message = 'Tidak ditemukan'
            if (state.error.message && state.error.status == 'failed') {
                message += ` (${state.error.message})`
            }

            return message
        }

        const highlight = value => {
            return value.replace(new RegExp(state.params.q, 'gi'), match => {
                return `<span style="background-color: yellow;">${match}</span>`
            })
        }

        return {
            state,
            valueState: useVModel(props, 'value'),
            highlight,
            onSearch,
            onHandleContent,
        }
    },
}
</script>